import { DistroActionTypes } from "./distro.types";

export const setCurrentDistro = (distro) => ({
  type: DistroActionTypes.SET_CURRENT_DISTRO,
  payload: distro,
});
